import { useTranslation } from 'react-i18next';
import { whyCards } from '@/mocks/seoContent';

export default function WhySection() {
  const { t } = useTranslation();

  return (
    <section className="w-full py-14 md:py-20 bg-white">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
            {t('why.title')}
          </h2>
          <p className="text-sm text-foreground-500 max-w-xl mx-auto">
            Kakobuy Spreadsheet to nie tylko lista produktów — to kompletne narzędzie, które zmienia sposób w jaki robisz zakupy z Chin.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {whyCards.map((card, idx) => (
            <div
              key={idx}
              className="group bg-background-50 rounded-lg p-6 md:p-8 border border-background-200 hover:border-primary-200 transition-all duration-300"
            >
              <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center bg-accent-100 rounded-lg mb-4 md:mb-5 group-hover:bg-accent-200 transition-colors">
                <i className={`${card.icon} text-xl md:text-2xl text-accent-600`}></i>
              </div>
              <h3 className="text-base md:text-lg font-heading font-semibold text-foreground-900 mb-2 md:mb-3">
                {card.title}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {card.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}